import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Collapse } from 'react-collapse';
import { withRouter } from 'react-router-dom';
import { getCardSearchFilterList } from './configStructure';
import {
  GDGolbalFilterSelectorRecentSearchList,
  GDGolbalFilterSelectorSearchManager,
} from 'Components/GDGolbalFilter';
import OutsideClickHandler from '../OutsideClickHandler';
import counterpart from "counterpart";
import ResponseBanner from 'Components/cards/ResponseBanner';

import './GDGolbalFilter.scss';
import ImagePortal from 'Containers/ImagePortal';
class GDGolbalFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      acqCode: JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
      searchText: '',
      iconType: '',
      isOpen: false,
      isSavingFilter: false,
      isSavedFilter: false,
      isSavedComplete: false,
      showRecentSearchList: false,
      showFavoritesList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
      activeItems: props.activeItems,
      tempActiveItems: props.activeItems,
      searchResultText: [],
      searchValue: '',
      searchQuery: '',
      typing: false,
      typingTimeout: 0,
      showValidationWarning: false,
      showWildcardSearchValidationMessage: false,
    };

    this.attachBindings();
  }

  updateRecentSearches(searchText = '', searches) {
    return searches;
  }

  attachBindings() {
    this.handleApply = this.handleApply.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDeleteFilter = this.handleDeleteFilter.bind(this);
    this.handleSaveFilter = this.handleSaveFilter.bind(this);
    this.handleSavingFilter = this.handleSavingFilter.bind(this);
    this.handleSavedFilter = this.handleSavedFilter.bind(this);
    this.handleSavedComplete = this.handleSavedComplete.bind(this);
    this.searchChangeHandler = this.searchChangeHandler.bind(this);
    this.searchRecentSelectHandler = this.searchRecentSelectHandler.bind(this);
    this.searchTextFocusHandler = this.searchTextFocusHandler.bind(this);
    this.toggleFavorites = this.toggleFavorites.bind(this);
    this.updateRecentSearches = this.updateRecentSearches.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if ((newProps.location.pathname).indexOf('globalsearch') !== 2) {
      this.setState({
        showFavoritesList: false,
        showSaveForm: false,
      });
    }
  }

  componentDidMount() {
    let role= JSON.parse(sessionStorage.getItem('state'))?.auth?.user?.role?.key;
    let acquirerUsers=['DiMS_ACQUIRER_ADMIN','DiMS_ACQUIRER_USER'];
    let isAcquirerUser=false
    if(acquirerUsers.findIndex(acquirer=>acquirer==role)!=-1){
      this.setState({
      isAcquirerUser:true,
      })  
    }
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keypress', this.onKeyPress);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
  }

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey + "_" + event.altKey) : event.key + "_" + event.ctrlKey + "_" + event.altKey;
    if(!this.state.isAcquirerUser && (event.code === "Enter" || event.code === "NumpadEnter")){
      this.validateInput(this.state.searchText);
    }
  }

  validateInput(inputText){
    const validationStar = this.state.searchText && this.state.searchText.split("*").length-1;
    const validationQutnMark = this.state.searchText && this.state.searchText.split("?").length-1;
    const pattern = (this.state.searchText && this.state.searchText.match(/^[0-9]+$/)) || (this.state.searchText && this.state.searchText.includes("*")) || (this.state.searchText && this.state.searchText.includes("?"));

    if(pattern){
      if(validationStar >  1 || validationQutnMark > 1 || (validationStar >=  1 && validationQutnMark >= 1) || (this.state.isAcquirerUser && (validationStar >=  1 || validationQutnMark >= 1 ))) {
        this.setState({
          showValidationWarning: true,
        });
      }
      else {
        this.setState({
          showWildcardSearchValidationMessage: true,
        });
        inputText && this.searchRecentSelectHandler('wildcard',inputText, ' in Wild Card');
      }
    }
    else if(this.state.searchText)  {
      this.setState({
        showValidationWarning: true,
      });
    }
  }

  renderWarningResponseBanner(){
    //const title = this.state.showValidationWarning ?     *enabling wildcard search*
    //'globalTranslate.globalSearch.validationMsg' : 
    //'globalTranslate.globalSearch.wildcardSearchNotAllowed';
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          //title= {counterpart('`${title}`')}    *enabling wildcard search*
          title= {counterpart('globalTranslate.globalSearch.validationMsg')}
          description=""
          type={this.state.acqCode=='HPY'? 'blackType' : 'danger'}
          onClose={this.closeBanner}
          cancelOnly
          cancelButtonText="CLOSE"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }

  closeBanner() {
    this.setState({
      showValidationWarning: false,
      //showWildcardSearchValidationMessage: false   *enabling wild card search*
    })
  }

  handleApply(updatedItems) {
    const { onApplySelections, onCollapse, onUpdateRecentSearches } = this.props;
    const updatedRecentSearches = this.searchResultText;

    this.setState({
      activeItems: updatedItems,
      tempActiveItems: updatedItems,
      searchText: '',
      isOpen: false,
      showRecentSearchList: false,
      showFavoritesList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
      recentSearches: updatedRecentSearches,
      showSavedSelectedMerchantTip: this.state.showSelectionsList,
    }, () => {
      onApplySelections(updatedItems);
      onUpdateRecentSearches(updatedRecentSearches);
      onCollapse();
    });
  }

  handleChecked(updatedTempItems) {
    this.setState({
      tempActiveItems: updatedTempItems,
    });
  }


  handleClose() {
    const { onCollapse } = this.props;
    this.setState({
      searchText: '',
      isOpen: false,
      showRecentSearchList: false,
      showFavoritesList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
    }, () => {
      onCollapse();
    });
  }

  handleClickOutside() {
    const { onCollapse } = this.props;
    this.setState({
      searchText: '',
      isOpen: false,
      showRecentSearchList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
    }, () => {
      onCollapse();
    });
    this.searchTextFocusHandler('');
  }

  toggleFavorites(searchValue, searchQuery) {
    const { showFavoritesList } = this.state;
    const { onCollapse, onExpand } = this.props;
    const isOpen = !showFavoritesList;
    this.setState({
      searchText: '',
      isOpen: false,
      showFavoritesList: isOpen,
      showRecentSearchList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
      searchValue,
      searchQuery,
    }, () => {
      isOpen ? onExpand() : onCollapse();
    });
  }

   toggleFavorites(searchValue, searchQuery, isclose, newSearchValue) {
    const { showFavoritesList } = this.state;
    const { onCollapse, onExpand } = this.props;
    let isOpen;
    isOpen = isclose ? false : !showFavoritesList;
    this.setState({
      searchText: newSearchValue,
      isOpen: false,
      showFavoritesList: isOpen,
      showRecentSearchList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
      searchValue,
      searchQuery,
    }, () => {
      isOpen ? onExpand() : onCollapse();
      this.setState({
        showFavoritesList: isOpen,
      })

      newSearchValue && this.searchChangeHandler(newSearchValue);
    });

    newSearchValue && this.searchChangeHandler(newSearchValue);
  }


  handleSaveFilter(name) {
    const { activeItems } = this.state;
    const { onSaveFilter, onCollapse } = this.props;
    this.setState({
      searchText: '',
      isOpen: false,
      showFavoritesList: false,
      showRecentSearchList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
    }, () => {
      this.handleSavingFilter(); /* loading animation */
      onSaveFilter(name, activeItems).then(() => {
        setTimeout(() => {
          this.handleSavedFilter(); /* check animation */
        }, 2000);
        setTimeout(() => {
          this.handleSavedComplete();
        }, 4000);
      });

      onCollapse();
    });
  }

  handleSavingFilter() {
    this.setState({
      iconType: 'saving',
      isSavingFilter: true,
      isSavedFilter: false,
      isSavedComplete: false,
    });
  }

  handleSavedFilter() {
    this.setState({
      iconType: 'saved',
      isSavingFilter: false,
      isSavedFilter: true,
      isSavedComplete: false,
    });
  }

  handleSavedComplete() {
    this.setState({
      iconType: 'default',
      isSavingFilter: false,
      isSavedFilter: false,
      isSavedComplete: true,
    });
  }

  handleDeleteFilter(name) {
    const { onDeleteFilter, onCollapse } = this.props;
    this.setState({
      searchText: '',
      isOpen: false,
      showFavoritesList: false,
      showRecentSearchList: false,
      showSearchList: false,
      showSelectionsList: false,
      showSaveForm: false,
    }, () => {
      onDeleteFilter(name);
      onCollapse();
    });
  }

 searchChangeHandler(searchText) {
    const searchResultText = getCardSearchFilterList(searchText,this.props.user.parsedPermissions);
    const { onExpand } = this.props;
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      // search function
    }, 300);

    this.setState({
      searchText,
      isOpen: true,
      showRecentSearchList: searchText === '',
      showFavoritesList: false,
      showSearchList: searchText !== '',
      showSelectionsList: false,
      showSaveForm: false,
      recentSearches: this.updateRecentSearches('', searchResultText),
    }, () => {
      onExpand();
    });
  }

  searchTextFocusHandler() {
    const { isOpen, showSearchList } = this.state;
    const { onExpand } = this.props;
    if (isOpen === false) return;
    this.setState({
      isOpen: false,
      showRecentSearchList: showSearchList === false,
      showFavoritesList: false,
      showSearchList: showSearchList === false,
      showSelectionsList: false,
      showSaveForm: false,
    }, () => {
      onExpand();
    });
  }
/**
   * Custom method to replace char at position in string
   * @param {*} string 
   * @param {*} index 
   * @param {*} replace 
   */
  replaceAt(string, index, replace) {
    return string.substring(0, index) + replace + string.substring(index + 1);
  }

  searchRecentSelectHandler(searchType, searchkey, searchQuery) {
    const validationStar = this.state.searchText && this.state.searchText.split("*").length-1;
    const validationQutnMark = this.state.searchText && this.state.searchText.split("?").length-1;
    const pattern = (this.state.searchText && this.state.searchText.match(/^[0-9]+$/)) || (this.state.searchText && this.state.searchText.includes("*")) || (this.state.searchText && this.state.searchText.includes("?"));

    if(pattern){
      if(validationStar >  1 || validationQutnMark > 1 || (validationStar >=  1 && validationQutnMark >= 1)|| (this.state.isAcquirerUser && (validationStar >=  1 || validationQutnMark >= 1 ))) {
        this.setState({
          showValidationWarning: true,
        });
      }
      else {
        
    const searchdata = {
      searchkey,
      searchType,
    };

    if (searchType == 'accountNumber') {
      let maskedCardNumber = searchkey;
      for (let i = 0; i < searchkey.length; i++) {
        if (i > 5 && i < searchkey.length - 4) {
          maskedCardNumber = this.replaceAt(maskedCardNumber, i, 'X');
        }
      }
      searchkey = maskedCardNumber;
    }
    if(!this.props.isMerchantUser && searchType === "caseNumber" && pattern == searchkey){
      this.props.history.push({
        state: {
          data: searchdata,
          prevPath: this.props.location.pathname,
        },
        pathname: '/caselanding/' + `${searchkey}`,
      });
    }
    else {
      this.props.history.push({
        state: {
          data: searchdata,
          prevPath: this.props.location.pathname,
        },
        pathname: `/globalsearch/${searchkey.replace(/\s/g, '')}/${searchType}`,
      });
    }
    this.toggleFavorites(searchdata.searchkey, searchQuery);
      }
    }
    else if(this.state.searchText)  {
      this.setState({
        showValidationWarning: true,
      });
    }
  }


  render() {
    const {
      iconType,
      isOpen,
      isSavedComplete,
      searchText,
      showFavoritesList,
      showSaveForm,
      activeItems,
      recentSearches,
    } = this.state;

    const {
      extraClass,
      setLocaleForMerchant,
    } = this.props;


    const wrapperClass = classnames('gd-hierarchy-selector', {
      [extraClass]: extraClass,
    });

    if(setLocaleForMerchant)
    {
      this.props.user && counterpart.setLocale(this.props.user.languageAbbr);
    }else{
      counterpart.setLocale("en-US");
    }

    const translations = {
      placeholder:`${counterpart('globalTranslate.globalSearch.searchBy')}...`
    }
    
    return (
      <OutsideClickHandler
        onClickOutside={this.handleClickOutside}
      >
        {this.state.showValidationWarning && this.renderWarningResponseBanner() }
        {this.props.user && this.props.user.parsedPermissions && this.props.user.parsedPermissions.search &&
          this.props.user.parsedPermissions.search.quickSearch &&
          (
            <div className={wrapperClass}>
              <GDGolbalFilterSelectorSearchManager
                className="something"
                searchText={searchText}
                numberSelected={activeItems.length}
                onFavoritesListClick={this.toggleFavorites}
                onRecentSearchListClick={this.toggleRecentSearchList}
                onSearchTextChange={this.searchChangeHandler}
                onSearchTextFocus={this.searchTextFocusHandler}
                triggerFavorites={showFavoritesList}
                triggerSaveSelectionForm={showSaveForm}
                translations={translations}
                iconType={iconType}
                saveComplete={isSavedComplete}
                showSavedSelectedMerchantTip={this.state.showSavedSelectedMerchantTip}
                searchValue={this.state.searchValue}
                searchQuery={this.state.searchQuery}
                toggleFavorites={this.toggleFavorites}
                searchChangeHandler={this.searchChangeHandler}
            />
            
            <Collapse isOpened={isOpen}  style={isOpen?{overflow: 'initial', height: 'auto'}:{overflow: 'hidden', height: '0px'}}>


                {<GDGolbalFilterSelectorRecentSearchList
                  className="something"
                  recentSearches={recentSearches}
                  onRecentSearch={this.searchRecentSelectHandler}
                  translations={this.props.translations}
                  searchText={this.state.searchResultText}
                />}

              </Collapse>
            </div >
          )
        }
      </OutsideClickHandler>
    );
  }

}

GDGolbalFilter.propTypes = {
  availableItems: PropTypes.array.isRequired,
  activeItems: PropTypes.array,
  extraClass: PropTypes.string,
  itemNameColumnName: PropTypes.string.isRequired,
  itemNumberColumnName: PropTypes.string.isRequired,
  onApplySelections: PropTypes.func,
  onCollapse: PropTypes.func,
  onDeleteFilter: PropTypes.func,
  onExpand: PropTypes.func,
  onSaveFilter: PropTypes.func,
  onUpdateRecentSearches: PropTypes.func,
  recentSearches: PropTypes.array,
  savedSelections: PropTypes.array,
  translations: PropTypes.object,
  typeIds: PropTypes.string.isRequired,
};

GDGolbalFilter.defaultProps = {
  activeItems: [],
  extraClass: '',
  onApplySelections: () => { },
  onCollapse: () => { },
  onDeleteFilter: () => { },
  onExpand: () => { },
  onSaveFilter: () => { },
  onUpdateRecentSearches: () => { },
  recentSearches: [],
  savedSelections: [],
  translations: {
    apply: 'Apply',
    availableItems: 'Available Items',
    browseAllItems: 'Browse All Merchant Numbers...',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    clearSelected: 'Clear Selected',
    createSavedSelection: 'To create a Saved Selection, search for Merchant Numbers you would like to save and click Save Selections.',
    currentSelected: 'Current Selected Item Numbers',
    itemsTitle: 'Merchant Number',
    moreThan30Selections: 'You already have 30 saved selections',
    name: 'Name',
    none: 'None',
    noSavedSelections: 'You don\'t have any Saved Selections',
    pluralText: 's',
    refineByItem: 'Search by',
    save: 'Save',
    savedSelections: 'Saved Selections',
    saveSelections: 'Save Selections',
    selectAll: 'Select All',
    viewSelections: 'View Selections',
    checkedItems: 'Checked Items',

  },
  isMerchantUser: true
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default withRouter(connect(mapStateToProps)(GDGolbalFilter));
